/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const folder_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M23 7.91c0-.905-.758-1.637-1.692-1.637h-11L8.277 3.655v0A1.712 1.712 0 0 0 6.923 3h-4.23v0C1.757 3 1 3.733 1 4.636v14.728C1 20.267 1.758 21 2.692 21h18.616v0c.934 0 1.692-.733 1.692-1.636V7.909Z"
    />
  </svg>
)
export default folder_medium
